<template>
  <v-container class="pa-0" fluid>
    <Hero />
    <About id="about" class="py-12" />
    <Features id="features" class="py-12" show-types="base" />
    <!--<Stats />-->
    <Contact class="py-12" />
  </v-container>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/home/Hero.vue";
import About from "@/components/home/About.vue";
import Features from "@/components/features/Features.vue";
import Contact from "@/components/home/Contact.vue";

export default {
  name: "Home",
  components: {
    Hero,
    About,
    Features,
    Contact
  }
};
</script>
